export default {
  /**
   * Set the global loading state
   * There's a watcher setup in App.vue to show a modal whenever this is true
   * @param state
   * @param payload
   */
  setLoading: (state, payload) => (state.loading = payload),
};
